/**
 * Date: 2020-12-22 16:21:09
 * description:
 *  @author zhizhan
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
import React from "react";
import { filterControl } from "./tools";
import { isString } from "lodash";
import Describe from "./Describe";
import { get, getBatch, set, cloneDeep } from "../../utils";

export const iocDescribe = function (controlItemParam) {
  const result = cloneDeep(controlItemParam);
  const describe = get(controlItemParam, "describe", null);
  if (isString(describe)) {
    const Dom = <Describe describe={describe} />;
    set(result, "afterNode", Dom);
  }
  return result;
};
/**
 * @description: 通过模版穿件col 配置参数
 * @param {*} rowData 模版
 * @param {*} colParam col 配置参数
 * @param {*} index_ 分组下标
 * @return: col 配置参数
 */
const colFactory = function (rowData, colParam, index_) {
  let result = rowData.map((col) => {
    const newCol = {
      ...col,
      controlItemParam: iocDescribe(col.controlItemParam),
    };
    const idStr = get(col, `controlItemParam.id`, "");
    set(newCol, `controlItemParam.id`, `[${index_}]${idStr}`);
    const className = [
      get(colParam, "className", ""),
      get(newCol, ["controlItemParam.inline", "block"], false) === true
        ? "inline_item"
        : "",
      get(newCol, ["controlItemParam.popup"], true) === true
        ? ""
        : "yx_incrementForm_col_nopopup",
    ];
    return {
      colParam: { ...colParam, className: className.join(" ") },
      controlList: [newCol],
    };
  });
  return result;
};
/**
 * @description: 创建row 配置参数
 * @param {*} rowData 模版
 * @param {*} colParam col 配置参数
 * @param {*} index_ 分组下标
 */
const rowFactory = function (rowData, colParam, index_) {
  const rowParam = { type: "flex", align: "middle" };
  const colArray = colFactory(rowData, colParam, index_);
  const result = { rowParam, col: colArray };
  return result;
};

/**
 * @description: 创建formItem Item配置
 * @param {array} items 自增模版
 * @return {json} row 配置
 * @param {*} index_ 分组下标
 */
const itemsFactory = function (items, index_) {
  let result = [items].map((rowData) => {
    const colParam = { className: "yx_incrementForm_col" };
    return rowFactory(rowData, colParam, index_);
  });
  return result;
};

const filterItems = function (items) {
  const result = items.filter((item) => {
    const trackConfig_ = get(item, "controlItemParam.iocParam.trackConfig", {});
    return filterControl(item, trackConfig_);
  });
  return result;
};

/**
 * 创建form元素
 *
 * @export
 * @param {*} groupParam 分组配置参数
 * @param {*} items 模版
 * @param {*} index_ 分组下标
 * @returns
 */
const createForm = function (groupParam, items, index_) {
  // const newItems = filterItems(items)
  return {
    groupParam: {
      isFold: false,
      showArrow: false,
      ...groupParam,
    },
    row: itemsFactory(items, index_),
  };
};

export default createForm;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxIncrementForm/createForm.js